"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var actions_1 = require("../utils/actions");
var actions_2 = require("./actions");
exports.initialState = {
    currentCouponByCountry: {},
    currentGlobalCouponByCountry: {},
    currentReferralByCountry: {},
    promoCode: '',
};
var setCurrentCoupon = function (state, action) {
    var _a;
    var _b = action.payload, country = _b.country, coupon = _b.coupon;
    return __assign(__assign({}, state), { currentCouponByCountry: __assign(__assign({}, state.currentCouponByCountry), (_a = {}, _a[country] = coupon, _a)) });
};
var setCurrentGlobalCoupon = function (state, action) {
    var _a;
    var _b = action.payload, country = _b.country, coupon = _b.coupon;
    return __assign(__assign({}, state), { currentGlobalCouponByCountry: __assign(__assign({}, state.currentGlobalCouponByCountry), (_a = {}, _a[country] = coupon, _a)) });
};
var setCurrentReferral = function (state, action) {
    var _a;
    var _b = action.payload, country = _b.country, referral = _b.referral;
    return __assign(__assign({}, state), { currentReferralByCountry: __assign(__assign({}, state.currentReferralByCountry), (_a = {}, _a[country] = referral, _a)) });
};
var setPromoCode = function (state, action) {
    var code = action.payload.code;
    return __assign(__assign({}, state), { promoCode: code });
};
var clearCurrentCoupon = function (state) {
    return __assign(__assign({}, state), { currentCouponByCountry: exports.initialState.currentCouponByCountry });
};
var clearCurrentGlobalCoupon = function (state) {
    return __assign(__assign({}, state), { currentGlobalCouponByCountry: exports.initialState.currentGlobalCouponByCountry });
};
var clearCurrentReferral = function (state) {
    return __assign(__assign({}, state), { currentReferralByCountry: exports.initialState.currentReferralByCountry });
};
var couponsReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    if ((0, actions_1.isType)(action, actions_2.setCurrentCouponAction)) {
        return setCurrentCoupon(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setCurrentGlobalCouponAction)) {
        return setCurrentGlobalCoupon(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setCurrentReferralAction)) {
        return setCurrentReferral(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setPromoCodeAction)) {
        return setPromoCode(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.clearCurrentCouponAction)) {
        return clearCurrentCoupon(state);
    }
    else if ((0, actions_1.isType)(action, actions_2.clearCurrentGlobalCouponAction)) {
        return clearCurrentGlobalCoupon(state);
    }
    else if ((0, actions_1.isType)(action, actions_2.clearCurrentReferralAction)) {
        return clearCurrentReferral(state);
    }
    else {
        return state;
    }
};
exports.default = couponsReducer;
